<div class="field" #fieldName>
    <span class="field-title">Sede<span class="asterisk">*</span></span>

    <div>
        <select-input [array]="array" [OBJECT]="OBJECT" [placeHolder]="'Ingresar una sede'" 
        [value]="elementSelected"
        (valueOut)="setElement($event)"></select-input>
    </div>

</div>